import {
  UPDATE_CONFIGURATION_DEFAULTS,
  UPDATE_CONFIGURATION_DEFAULTS_DONE,
  UPDATE_CONFIGURATION_DEFAULTS_ERROR,
  UPDATE_CONFIGURATION_DEFAULTS_LOADING,
  UPDATE_CONFIGURATION_DEFAULTS_SUCCESS
} from './actionTypes';
import makeActionCreator from './makeActionCreator';

export const updateConfigurationDefaults = makeActionCreator(UPDATE_CONFIGURATION_DEFAULTS,
  'tenantId', 'restrictSelfLaunch', 'showCodeOfConduct', 'allowPdfs', 'allowImages', 'enableShortLinks');
export const updateConfigurationDefaultsLoading = makeActionCreator(
  UPDATE_CONFIGURATION_DEFAULTS_LOADING);
export const updateConfigurationDefaultsSuccess = makeActionCreator(
  UPDATE_CONFIGURATION_DEFAULTS_SUCCESS, 'tenant');
export const updateConfigurationDefaultsError = makeActionCreator(
  UPDATE_CONFIGURATION_DEFAULTS_ERROR, 'error');
export const updateConfigurationDefaultsDone = makeActionCreator(
  UPDATE_CONFIGURATION_DEFAULTS_DONE);

